<script>
import { authComputed } from '@/store/helpers'

import MetisMenu from 'metismenujs/dist/metismenujs'

export default {
  components: {},
  computed: {
    ...authComputed,
  },
  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu('#side-menu')
    var links = document.getElementsByClassName('side-nav-link-ref')

    var matchingMenuItem = null
    for (var i = 0; i < links.length; i++) {

      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break
      }
    }

    if (matchingMenuItem) {

      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active')
        const parent2 = parent.parentElement

        if (parent2 && !parent2.querySelector('.metismenu')) {
          parent2.classList.add('in')
          parent2.classList.add('mm-show')
        }
        const parent3 = parent2.parentElement

        if (parent3 && !parent3.querySelector('.metismenu')) {
          parent3.classList.add('active')
          var childAnchor = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('active')
        }

        const parent4 = parent3.parentElement
        if (parent4 && !parent4.querySelector('.metismenu'))
          parent4.classList.add('in')

        const parent5 = parent4.parentElement
        if (parent5 && !parent5.querySelector('.metismenu'))
          parent5.classList.add('active')

      }
    } else {
      var home = document.getElementsByClassName('home-menu')
      if (home) home[0].classList.add('active')

    }
  },
  methods: {
    /**
     * small sidebar
     */
    smallSidebar() {
      document.body.classList.add('left-side-menu-sm')
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.remove('topbar-light')
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('enlarged')
    },

    /**
     * Dark sidebar
     */
    darkSidebar() {
      document.body.classList.remove('left-side-menu-sm')
      document.body.classList.add('left-side-menu-dark')
      document.body.classList.remove('topbar-light')
      document.body.classList.remove('boxed-layout')
    },

    /**
     * Light Topbar
     */
    lightTopbar() {
      document.body.classList.add('topbar-light')
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.remove('left-side-menu-sm')
      document.body.classList.remove('boxed-layout')
    },

    /**
     * Sidebar collapsed
     */
    sidebarCollapsed() {
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.remove('left-side-menu-sm')
      document.body.classList.toggle('enlarged')
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('topbar-light')
    },

    /**
     * Boxed Layout
     */
    boxedLayout() {
      document.body.classList.add('boxed-layout')
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.add('enlarged')
      document.body.classList.remove('left-side-menu-sm')
    },
  },
}
</script>

<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul id="side-menu" class="metismenu">
      <li class="menu-title">Navigation</li>
      <li>
        <router-link tag="a" :to="{ name: 'home' }" class="home-menu">
          <i class="fe-home"></i>
          <span>HOME</span>
        </router-link>
      </li>
      <li v-if="checkPermission(['ReadJob'])">
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-shopping-cart"></i>
          <span>JOB</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li v-if="checkPermission(['ReadJob'])">
            <router-link tag="a" :to="{ name: 'job-inspect' }" class="side-nav-link-ref">ตรวจสอบงาน</router-link>
          </li>
 
        </ul>
      </li>
      <li v-if="checkPermission(['ReadJob'])">
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-file-text"></i>
          <span>REPORT</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li v-if="checkPermission(['ReadJob'])">
            <router-link tag="a" :to="{ name: 'report-agentorder-personal' }" class="side-nav-link-ref">รายงานแจ้งงาน ส่วนตัว</router-link>
          </li>
          <li v-if="checkPermission(['ReadJob'])">
            <router-link tag="a" :to="{ name: 'report-agentorder' }" class="side-nav-link-ref">รายงานแจ้งงาน รวมทีมงาน</router-link>
          </li>
          <li v-show="checkPermission(['ReadPayment'])">
            <router-link tag="a" :to="{name: 'report-agentorder-appuplevel'}" class="side-nav-link-ref">รายงานยอดขายปรับระดับ</router-link>
          </li>
          <li v-if="checkPermission(['ReadJob'])">
            <router-link tag="a" :to="{ name: 'job-check-renew' }" class="side-nav-link-ref">ตรวจสอบงานปีต่อ (ใกล้ครบกำหนดชำระ)</router-link>
          </li>
          <!-- <li v-show="checkPermission(['ReadJob'])">
            <router-link tag="a" :to="{ name: 'job-inspect' }" class="side-nav-link-ref">ตรวจสอบงาน</router-link>
          </li> -->
          <li v-if="checkPermission(['ReadPayment']) && $store.state.MenuWhtc50.IsShowMenu && $store.state.CitizenType == 1">
            <router-link tag="a" :to="{ name: 'agent-whtc' }" class="side-nav-link-ref">50 ทวิ</router-link>
          </li>
        </ul>
      </li>
      <li>
        <router-link tag="a" :to="{ name: 'admin-change-password' }" class="side-nav-link-ref">
          <i class="fe-lock"></i>
          <span>CHANGE PASSWORD</span>
        </router-link>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
  <!-- End Sidebar -->
</template>

<style lang="scss">
@import '~metismenujs/scss/metismenujs';
</style>

